<h1 class="page-title">Báb misszió</h1>

<p class="illustrated">
  <img src="/assets/bab2.jpg"
       alt="Pillanatkép egy bábos jelenteből"
  />
  Gyülekezetünkben 2005 tavaszán indult a bábszínház, a Palánta Sorsfordító Alapítvány színeiben. Évente kétszer, a
  Húsvéti és a Karácsonyi ünnepkör előtt visszük el az evangéliumot a bábdarabokkal a gyermekekhez. Minden alkalommal új
  darabot viszünk, amely aktuális társadalmi problémákat boncolgat, olyan formában, hogy a gyerekek is könnyen
  megértsék, élvezzék és megjegyezzék. A mesejáték sok zenével válik élményszerűvé, a korosztály szintjén mondja el a
  Húsvét vagy a Karácsony VALÓDI üzenetét. Nagyon fontosnak ítéljük a gyerekekkel való foglalkozást, hogy teljes
  figyelmet kapjanak. Az alkalom fontos része a beszélgetés, az énektanítás.
</p>

<p class="illustrated">
  <img src="/assets/bab5.jpg"
       alt="Nagyon sok gyermekhez jut el az örömhír"
       class="right"
  />
  Az évek során Somogy megyében minden olyan iskolába eljutottunk, ahol szerették volna az előadást megtekinteni. Egy-
  egy időszakban mintegy 3500 kisiskolás és óvodás láthat keresztény értékeket közvetítő és átadó bábelőadást, és vihet
  haza ajándékot. Sok esetben a halmozottan hátrányos helyzetű kistérségekben élő gyerekeknek az egyetlen karácsonyi,
  vagy húsvéti meglepetése az általunk vitt CD, kifestő volt. Az ajándékok a gyülekezet tagjainak adományaiból lettek
  megvásárolva, csakúgy, mint a felszerelés, az újabb és újabb bábok, eszközök. Az útiköltséget is adományokból
  fedezzük. A bábcsapat tagjai önkéntes munkát végeznek. Ez igazi csapatmunka!
</p>

<p class="illustrated">
  <img src="/assets/bab7.jpg"
       alt="Beszélgetés a gyerekekkel"
  />
  Rendkívül jó kapcsolatunk alakult ki a pedagógusokkal, megosztják velünk az iskolák gondjait, szívesen várnak,
  szeretettel látnak bennünket. A gyerekek is ismerősként üdvözölnek, tudják a nevünket, kérdezgetnek rólunk, az
  életünkről. Hatalmas kapcsolati tőkénk alakul ki ez által! A megye sajátos aprófalvas településszerkezetéből adódó
  "eldugott" falvakban is megjelenünk évente kétszer. Független (nem ünnephez kötődő) darabjainkat falunapokon,
  gyermektáborokban, egyéb rendezvényeken adjuk elő.
</p>

<p>
  <strong>Ha szeretné meghívni egy intézménybe vagy egy rendezvényre a bábcsapatunkat, kérjük
    <a [routerLink]="['/kapcsolat']">vegye fel velünk a kapcsolatot</a>!</strong>
</p>

<p>
  <a href="http://www.palantamisszio.hu/" target="_blank">
    <img src="/assets/palanta.png"
         alt="Palánta Misszió"
    />
    A Palánta Misszió honlapja
  </a>
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/puppet/puppet.component.html